<!-- Header -->
<div class="header right">
  <div class="container">
    <div class="header-logo">
      <h3 class="font-family-syne letter-spacing-1">
        <a routerLink="/">Komo</a>
      </h3>
    </div>

    <!-- Menu -->
    <div class="header-menu" [ngClass]="{ 'show': isMenuOpen }">
      <ul class="nav">
        <!-- Dropdown Item -->
        <li class="nav-item">
          <a class="nav-link" [ngClass]="{ 'd-toggle': true }" href="javascript:void(0)" (click)="toggleDropdown(0)">Home</a>
          <ul class="nav-dropdown" [ngClass]="{ 'show': isMenuOpen && activeDropdown === 0 }">
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/">Startup Agency</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/home-two">Design Agency</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/home-three">Corporate Business</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/home-four">Consulting</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/home-five">Digital Agency</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/home-six">SEO Agency</a></li>
          </ul>
          <!-- Toggle Link Icon -->
          <a href="javascript:void(0)" class="nav-dropdown-toggle" [ngClass]="{ 'active': isMenuOpen && activeDropdown === 0 }" (click)="toggleDropdown(0)"></a>
        </li>

        <li class="nav-item">
          <a class="nav-link" [ngClass]="{ 'd-toggle': true }" href="javascript:void(0)" (click)="toggleDropdown(1)">Pages</a>
          <ul class="nav-dropdown" [ngClass]="{ 'show': isMenuOpen && activeDropdown === 1 }">
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/about-us">About Us</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/our-team">Our Team</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/team-details">Team Details</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/testimonials">Testimonials</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/pricing-table">Pricing Table</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/404-page">404 Error Page</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/coming-soon">Coming Soon</a></li>
          </ul>
          <!-- Toggle Link Icon -->
          <a href="javascript:void(0)" class="nav-dropdown-toggle" [ngClass]="{ 'active': isMenuOpen && activeDropdown === 1 }" (click)="toggleDropdown(1)"></a>
        </li>

        <li class="nav-item">
          <a class="nav-link" [ngClass]="{ 'd-toggle': true }" href="javascript:void(0)" (click)="toggleDropdown(2)">Services</a>
          <ul class="nav-dropdown" [ngClass]="{ 'show': isMenuOpen && activeDropdown === 2 }">
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/services">Services</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/service-two">Service Two</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/service-three">Service Three</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/service-four">Service Four</a></li>
          </ul>
          <!-- Toggle Link Icon -->
          <a href="javascript:void(0)" class="nav-dropdown-toggle" [ngClass]="{ 'active': isMenuOpen && activeDropdown === 2 }" (click)="toggleDropdown(2)"></a>
        </li>

        <li class="nav-item">
          <a class="nav-link" [ngClass]="{ 'd-toggle': true }" href="javascript:void(0)" (click)="toggleDropdown(3)">Portfolio</a>
          <ul class="nav-dropdown" [ngClass]="{ 'show': isMenuOpen && activeDropdown === 3 }">
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/portfolio-two-column">Portfolio Two Columns</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/portfolio-three-column">Portfolio Three Columns</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/portfolio-four-column">Portfolio Four Columns</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/portfolio-detail">Portfolio Details</a></li>
          </ul>
          <!-- Toggle Link Icon -->
          <a href="javascript:void(0)" class="nav-dropdown-toggle" [ngClass]="{ 'active': isMenuOpen && activeDropdown === 3 }" (click)="toggleDropdown(3)"></a>
        </li>

        <li class="nav-item">
          <a class="nav-link" [ngClass]="{ 'd-toggle': true }" href="javascript:void(0)" (click)="toggleDropdown(4)">Blogs</a>
          <ul class="nav-dropdown" [ngClass]="{ 'show': isMenuOpen && activeDropdown === 4 }">
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/blog-grid">Blog Grid</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/blog-standard">Blog Standard</a></li>
          </ul>
          <!-- Toggle Link Icon -->
          <a href="javascript:void(0)" class="nav-dropdown-toggle" [ngClass]="{ 'active': isMenuOpen && activeDropdown === 4 }" (click)="toggleDropdown(4)"></a>
        </li>

        <li class="nav-item" (click)="closeMenu()">
          <a class="nav-link" routerLink="/contact">Contact Us</a>
        </li>
      </ul>
    </div>

    <!-- Social Icons -->
    <div class="header-menu-extra">
      <ul class="list-inline-sm">
        <li><a href="/"><i class="bi bi-facebook"></i></a></li>
        <li><a href="/"><i class="bi bi-twitter-x"></i></a></li>
        <li><a href="/"><i class="bi bi-linkedin"></i></a></li>
      </ul>
    </div>

    <!-- Menu Toggle -->
    <button class="header-toggle" [class.toggle-close]="isMenuOpen" (click)="toggleMenu()">
      <span></span>
    </button>
  </div>
</div>
<!-- end Header -->

<!-- Hero section -->
<div class="section-xl pb-0">
    <div class="container">
        <div class="row align-items-center g-4 g-lg-5">
            <div class="col-12 col-lg-6 order-lg-2 text-center text-lg-end m-0">
                <img src="assets/images/slides/illustration-banner-1.png" alt="banner-1">
            </div>
            <div class="col-12 col-lg-6 order-lg-1 text-center text-lg-start m-0">
                <h1 class="fw-semi-bold display-4 line-height-110 mb-4 font-family-syne">Innovative IT Solutions
                    Driving Your Competitive Advantage</h1>
                <div class="d-flex align-items-center mb-4 mb-lg-5">
                    <ul class="avatar-group">
                        <li>
                            <img src="assets/images/testimonials/client-1-sm.jpg" alt="client-1">
                        </li>
                        <li>
                            <img src="assets/images/testimonials/client-2-sm.jpg" alt="client-2">
                        </li>
                        <li>
                            <img src="assets/images/testimonials/client-3-sm.jpg" alt="client-3">
                        </li>
                    </ul>
                    <div class="d-inline-block ps-3">
                        <p>We've over 4,000 clients <br class="d-md-block">around the world</p>
                    </div>
                </div>
                <a class="button button-lg button-rounded button-font-2 button-gradient-6 lightbox-media-link" (click)="openPopup()"><i class="bi bi-play-fill"></i>Play Video</a>
            </div>
        </div><!-- end row -->
    </div><!-- end container -->
</div>
<!-- end Hero section -->

<!-- Video Popup -->
<div class="video-popup" *ngIf="isOpen">
    <div class="popup-inner">
        <iframe width="560" height="315" src="https://www.youtube.com/embed/VkV8BGdn28I?si=rcRjoSyXVoFtNfn7" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        <button (click)="closePopup()" type="button" class="close-btn">
            <i class='bi bi-x'></i>
        </button>
    </div>
</div>

<!-- Services section -->
<div class="section-lg">
    <div class="container text-center icon-5xl">
        <div class="row g-4">
            <div class="col-12 col-lg-4" *ngFor="let item of features">
                <div class="border-radius p-4 p-lg-5 hover-float" [ngClass]="item.bgClass + ' ' + item.extraClass">
                    <div class="text-dark mb-2">
                        <i class="bi" [ngClass]="item.icon"></i>
                    </div>
        
                    <h5 class="text-dark font-family-syne">
                        {{ item.title }}
                    </h5>
        
                    <p class="text-dark-06">
                        {{ item.description }}
                    </p>
                </div>
            </div>
        </div><!-- end row -->
    </div><!-- end container -->
</div>
<!-- end Services section -->

<!-- Clients section -->
<div class="section pt-0">
    <div class="container">
        <owl-carousel-o [options]="brandCarouselOptions" class="client-carousel">
            <ng-template carouselSlide *ngFor="let brand of brands">
                <div class="client-box">
                    <a routerLink="/">
                        <img [src]="brand.image" [alt]="brand.alt">
                    </a>
                </div>
            </ng-template>
        </owl-carousel-o><!-- end owl-carousel -->
    </div><!-- end container -->
</div>
<!-- end Clients section -->

<!-- About section -->
<div class="section-lg pt-0">
    <div class="container text-center text-lg-start">
        <div class="row align-items-center g-4 g-lg-5">
            <div class="col-12 col-lg-6">
                <img src="assets/images/slides/illustration-banner-2.png" alt="illustration-2">
            </div>
            <div class="col-12 col-lg-6">
                <h6 class="d-inline-block bg-gray border-radius px-3 py-2 line-height-140 font-small letter-spacing-1 mb-3"><span class="text-gradient-6 font-family-syne">About us</span></h6>
                <h2 class="display-6 fw-normal mb-3 font-family-syne">We help businesses to become inescapable in a digital world
                </h2>
                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
                    tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
                    quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo</p>
                <a class="button button-lg button-rounded button-font-2 button-gradient-6 mt-4" routerLink="/contact">Learn more</a>
            </div>
        </div><!-- end row -->
    </div><!-- end container -->
</div>
<!-- end About section -->

<!-- Process section -->
<div class="section pt-0">
    <div class="container">
        <div class="row">
            <div class="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2 col-xl-6 offset-xl-3 text-center"
                data-cues="fadeIn">
                <h6 class="d-inline-block bg-white box-shadow border-radius px-3 py-2 line-height-140 font-small font-family-syne letter-spacing-1 mb-3"><span class="text-gradient-6">Our Process</span></h6>
                <h2 class="display-6 fw-normal font-family-syne">Our Approach to SEO</h2>
            </div>
        </div><!-- end row -->
        <div class="row g-4 g-lg-5 mt-4">
            <div class="col-12 col-md-6 col-lg-3" *ngFor="let item of processSteps">
                <div class="circle-box-lg bg-gradient-6 box-shadow mb-3">
                    <h3 class="text-white font-family-syne">
                        {{ item.step }}
                    </h3>
                </div>
                <h5 class="font-family-syne">
                    {{ item.title }}
                </h5>
                <p>
                    {{ item.description }}
                </p>
            </div>
        </div><!-- end row -->
    </div><!-- end container -->
</div>
<!-- end Process section -->

<!-- Parallax section -->
<div class="section-xl bg-image parallax" style="background-image: url('assets/images/backgrounds/parallax-bg.jpg');">
    <div class="bg-dark-03">
        <div class="container text-center">
            <div class="row g-4">
                <div class="col-12 col-sm-10 offset-sm-1 col-md-8 offset-md-2 col-lg-6 offset-lg-3">
                    <h2 class="display-4 font-family-syne fw-medium">Ready to Elevate Your IT Strategy?</h2>
                    <p>Maecenas nec odio et ante tincidunt tempus. Nullam quis ante. Etiam sit amet orci eget eros
                        faucibus tincidunt.</p>
                    <a class="button button-lg button-radius button-outline-white mt-4" routerLink="/contact">Call Us</a>
                </div>
            </div><!-- end row -->
        </div><!-- end container -->
    </div>
</div>
<!-- end Parallax section -->

<!-- Testimonial section -->
<div class="section">
    <div class="container">
        <div class="bg-light-blue border-radius-1 px-4 px-lg-5 py-5">
            <owl-carousel-o [options]="customOptions" class="owl-btn-center-lr testimonial-inner mrt-80">
                <ng-template carouselSlide *ngFor="let slide of slideStore">
                    <!-- Testimonial box -->
                    <div class="testimonial-box">
                        <img class="mb-3" src="assets/images/testimonials/{{slide.image}}" alt="client-img">
                        <h5 class="fw-normal line-height-140 m-0 font-family-syne">{{slide.title}}</h5>
                        <span class="font-small fw-normal">{{slide.subtitle}}</span>
                        <p class="mt-3">{{slide.desc}}</p>
                    </div>
                </ng-template>
            </owl-carousel-o><!-- end owl-carousel -->
        </div>
    </div><!-- end container -->
</div>
<!-- end Testimonial section -->

<!-- Prices section -->
<div class="section">
    <div class="container">
        <div class="row align-items-center g-5">
            <div class="col-12 col-lg-5">
                <h6 class="d-inline-block bg-white box-shadow border-radius px-3 py-2 line-height-140 font-small font-family-syne letter-spacing-1 mb-3"><span class="text-gradient-6">Pricing Plans</span></h6>
                <h2 class="font-family-syne">Bridging Technology and Business Success Since 2008</h2>
                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
                tempor incididunt ut labore et dolore</p>
            </div>
            <div class="col-12 col-lg-7">
                <div class="row g-4">
                    <div class="col-12 col-md-6" *ngFor="let plan of pricingPlans">
                        <div class="hover-float border-radius p-4 p-lg-5" [ngClass]="[plan.bgClass, plan.extraClass]">
                            <h6 class="font-small font-family-syne letter-spacing-1">
                                <span>{{ plan.title }}</span>
                            </h6>
                
                            <div class="mt-3">
                                <h1 class="line-height-100 font-family-syne fw-medium mb-0">
                                    {{ plan.price }}
                                </h1>
                                <span>{{ plan.duration }}</span>
                            </div>
                
                            <ul class="list-unstyled mt-4">
                                <li *ngFor="let feature of plan.features">
                                    {{ feature }}
                                </li>
                            </ul>
                
                            <a class="button button-md button-font-2 button-theme button-gradient-6 button-rounded mt-4" routerLink="/pricing-table">Select Plan</a>
                        </div>
                    </div>
                </div><!-- end row(inner) -->
            </div>
        </div><!-- end row(outer) -->
    </div><!-- end container -->
</div>
<!-- end Prices section -->